import { nanoid } from 'nanoid'
import React from 'react'
import { checkTranslation, getObject, setObject, translate } from '../../utils/useful'
import ButtonAnimated from '../buttons/ButtonAnimated'
import Modal from '../Modal'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { getBoundingClientRect } from '../../utils/functions'
import FixedView from '../FixedView'
import SwitchInput from './SwitchInput'
import HttpServices from '../../utils/Http.services'
// import { Draggable } from 'react-smooth-dnd'
// import FormViewer from '../FormViewer'
// import { apisList } from '../../variables/config'
// import { index } from 'd3'


class ApisInput extends React.Component {
    state = {
        choiceOption: [
            {}
        ],
        firtRow: { title: '', value: nanoid() },
        fields: [

            { key: 'name', type: 'TextInput', information: { isSearchable: true, label: '{{lang}}Reference name', hint: "{{lang}}The fetched value can be recalled in the page using this name.", required: true }, },
            { key: 'collection', type: 'AdvancedMultiTreeSelect', information: { isSearchable: true, label: '{{lang}}Collection', address: 'getFramesApplet', filter: { appletPopulate: true }, fields: { title: 'name', value: '_id', image: 'image', mainParent: 'applet', parent: 'parents', type: 'type' }, type: 'api', placeholder: '{{lang}}Select Collection', required: true }, },
            // { key: 'API', type: 'SelectInput', information: { label: '{{lang}}API', type: 'local', items: [], placeholder: '{{lang}}select', required: true } },
            // { key: 'Filter', type: 'FilterEditorInput', information: { label: '{{lang}}Filter',inputClass:'bordered-input', placeholder: '{{lang}}select', required: true } },

        ],
        params: [
            // { id: '1', name: 'category', type: 'path' },
            // { id: '2', name: 'provider', type: 'path' },
            // { id: '3', name: 'name', type: 'query' },
            // { id: '4', name: 'age', type: 'query' },

        ],

        paramsActions: [
            { key: 'edit', label: translate('Edit'), icon: '/assets/icons/useful/edit.png', color: '#007aff' },
            { key: 'remove', label: translate('Remove'), icon: '/assets/icons/useful/trash.png', color: '#ee5050' },
        ]
    }


    componentDidMount() {

        // let apis = []

        // Object.entries(apisList)?.map(([key, value]) => {
        //     if (value.features) {
        //         let api = value
        //         api.value = key
        //         api.title = value.label
        //         apis.push(api)
        //     }
        // })

        // this.setState({ apis })

        // if (!this.props.data || this.props.data.length == 0) {
        //     this.addHandler()
        // }
        this.refreshFixedViews()

        // if (this.props.fullData[this.props.header?.paramsKey]) {
        // }
    }



    // componentDidUpdate(prevProps) {

    //     if (this.props.fullData != prevProps.fullData) {
    //         this.setState({ params: this.props.fullData[this.props.header?.paramsKey] ?? [] })
    //     }

    // }


    changeValue(value) {
        this.props.changeValue(this.props.header.key, value, this.props.extra)
    }

    refreshFixedViews = () => {

        this.setState({ showFixedViews: false })
        setTimeout(() => {
            this.setState({ showFixedViews: true })
        }, 100)

    }
    // addHandler = () => {
    //     let data = this.props.data ?? []
    //     data.push({ value: nanoid() })
    //     this.changeInputValue(data)
    // }


    removeHandler = (index) => {
        let data = this.props.data
        let indexx = index
        // let y=data.index[indexx]
        // console.log('eeeeeeee', index);
        // if (data.length < 2) {
        //     alert('nooooo')
        // } else {
        data.splice(index, 1)
        this.changeInputValue(data)
        // }
    }

    changeRowValue = (key, value, index) => {

        // console.log("changeRowValue")
        let data = this.props.data

        if (!Array.isArray(data)) {
            data = [{}]
        }
        // console.log(value)
        // data[index].title = value
        setObject(data[index], key, value)
        console.log(data)
        this.changeInputValue(data)
    }


    liveChange = (data, init, key, value, extra, full) => {

        if (!init && (extra?.index != null)) {
            this.changeRowValue(key, value, extra.index)
        }
    }

    submitSlug = () => {

        let slug = this.state.slug
        if (!slug || slug.length == 0) {

            this.props.actions.addNotif({ type: 'error', title: '{{lang}}Not valid', description: translate("Slug can not be empty") })
            return
        }

        const slugPattern = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
        const isValid = slugPattern.test(slug);

        if (!isValid) {
            this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.canNotChange', description: translate("Slug should only contain lowercase letters, numbers, and hyphens. Spaces and special characters are not allowed.") })
            return
        }

        this.setState({ isLoadingSlug: true })

        let body = {
            applet: this.props.variables?.applet?._id,
            frame: this.props.variables?.page?._id,
            slug: slug,
        }

        console.log(body)

        HttpServices.request('checkPageSlug', body, (fetchResult, fetchError) => {

            this.setState({ isLoadingSlug: false })

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.faild', description: fetchError.message })
                return
            }
            // let data = this.props.data ?? {}
            // data.slug = slug
            this.props.changeValue(this.props.header.key, slug, this.props.extra)
            this.slugModal.close()

        })


    }


    openEditSlug = () => {

        this.setState({ slug: this.props.data })
        this.slugModal.open()

    }


    openEditParams = () => {
        this.paramsModal.open()
        this.refreshFixedViews()
        this.setState({ params: getObject(this.props.fullData, this.props.header?.paramsKey) ?? [] })


    }

    onDragEnd = (result, type) => {

        let items = Array.from(this.state.params);

        let queryParams = items ? items.filter((a) => { return a.type == 'query' }) : []
        let pathParams = items ? items.filter((a) => { return a.type == 'path' }) : []

        let myParams = type == 'query' ? queryParams : pathParams

        let [reorderItem] = myParams.splice(result.source.index, 1);
        // console.log(reorderItem)

        myParams.splice(result.destination.index, 0, reorderItem);
        this.setState({ params: [...pathParams, ...queryParams] }, () => {

            this.refreshFixedViews()

        })
    }

    actionClicked = (item, param) => {

        if (item.key == 'edit') {
            this.editParam(param)
        } else if (item.key == 'remove') {
            this.removeParam(param)
        }

    }



    submitParam = () => {
        let param = this.state.currentParam
        let params = this.state.params


        if (param.name && param.type) {

            const slugPattern = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
            const isValid = slugPattern.test(param.name);
            if (isValid) {
                if (param.id) {
                    let index = params.findIndex((a) => { return a.id == param.id })
                    if (index > -1) {
                        params[index] = param
                    }
                } else {
                    param.id = nanoid()
                    params.push(param)
                }

                this.setState({ params }, () => {
                    this.refreshFixedViews()
                })
                // this.changeParamValue(params)


            } else {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.notValid', description: translate("Param name should only contain lowercase letters, numbers, and hyphens. Spaces and special characters are not allowed.") })
                return
            }
        } else {
            this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.canNotChange', description: translate("Please fill all fields") })
        }

        this.editParamModal.close()
    }


    addParam = (type) => {

        this.setState({ currentParam: { type } })

        this.editParamModal.showModal()

    }


    editParam = (param) => {

        this.setState({ currentParam: JSON.parse(JSON.stringify(param)) })
        this.editParamModal.showModal()

    }


    removeParam = (param) => {

        let params = this.state.params
        let index = params.findIndex((a) => { return a.id == param.id })
        if (index > -1) {
            params.splice(index, 1)
        }


        this.setState({ params }, () => {

            this.refreshFixedViews()

        })
    }


    submitParamsValue = () => {

        let params = this.state.params
        // this.setState({ params }, () => {

        this.props.changeValue(this.props.header.paramsKey, params, this.props.extra)
        this.refreshFixedViews()
        this.paramsModal.close()


        // })

    }

    changeCurrentParamValue = (key, value) => {
        let param = this.state.currentParam
        param[key] = value
        this.setState({ currentParam: param })
    }


    render() {


        let variables = this.props.variables
        // let params = [
        //     // { type: 'path', key: '1233', label: 'name', required: true },
        //     // { type: 'query', key: '234', label: 'id' },
        //     // { type: 'query', key: 'age', label: 'age' },

        // ]

        let params = this.state.params ?? []
        let finalParams = getObject(this.props.fullData, this.props.header?.paramsKey) ?? []


        let queryParams = params ? params.filter((a) => { return a.type == 'query' }) : []
        let pathParams = params ? params.filter((a) => { return a.type == 'path' }) : []


        let finalQueryParams = finalParams ? finalParams.filter((a) => { return a.type == 'query' }) : []
        let finalPathParams = finalParams ? finalParams.filter((a) => { return a.type == 'path' }) : []

        // if (params.filter((a) => { return a.type == 'query' }).length > 0) {
        //     hasQueryParam = true
        // }
        let colors = this.props.colors


        // console.log(this.props.data)

        return (
            <div className=''>
                <div className='modern-input flexc flex-wrap'>
                    <p className='text-smaller opacity-5'><span>https://yonnect.com/{variables?.hub?.username}/</span>{variables?.applet?.slug}/</p>
                    <p className='text-small'>
                        <button className='br-4 px-1 py-0 mx-1' onClick={() => this.openEditSlug()} style={{ background: '#ddd' }}>{(this.props.data ?? variables.page?._id) ?? translate("*Pending*")}</button>
                        {finalPathParams && finalPathParams.map((param, index) => {
                            // if (param.type == 'path')
                            return (
                                <span>
                                    /<button className='br-4 px-1 py-0 mx-1' style={{ background: '#ddd' }}>{param.name}</button>
                                </span>
                            )
                        })}
                        {/* {hasQueryParam && (
                            <span>?</span>
                        )} */}
                        {finalQueryParams && finalQueryParams.map((param, index) => {
                            // if (param.type == 'query')
                            return (
                                <span>
                                    {index == 0 ? '?' : '&'}<button className='br-4 px-1 py-0 mx-1' style={{ background: '#ddd' }}>{param.name} = {"< " + param.name + " >"}</button>
                                </span>
                            )
                        })}

                    </p>
                </div>
                {/* {Array.isArray(list) && list.map((item, index) => {
                    return (
                        <div className="w-100 flexc flex-column pt-3" style={{ borderBottom: '1px solid #eee' }}>
                            <FormViewer ref={el => this.form = el} initData={item} headers={this.state?.fields} formClass="modern" inputClass={'modern-input'} liveChange={this.liveChange} extra={{index}} />
                            <div className='w-100 px-3 mb-3 flexce'>
                                <button style={{ color: '#ee5050' }} onClick={() => this.removeHandler(index)}>
                                    <p>{translate('Remove Row')}</p>
                                </button>
                            </div>
                        </div>
                    )
                })} */}
                <div className='px-2 py-1'>


                    <button className='mrd-5' onClick={() => this.openEditSlug()}>
                        <p className='text-smaller' style={{ color: '#007aff' }}>{translate("Edit page slug")}</p>
                    </button>

                    <button className='mrd-4' onClick={() => this.openEditParams()}>
                        <p className='text-smaller' style={{ color: '#007aff' }}>{translate("Edit dynamic Param")}</p>
                    </button>


                </div>




                <Modal ref={el => this.slugModal = el} maxWidth={400}>
                    <div className="d-flex flex-column p-4 pb-5 br-15 bg-white">
                        <p className='text-semibig text-bold'>{translate(`Edit page slug`)}</p>

                        <p className='text-smaller mt-2 color-gray-2'>{translate("The slug is the unique identifier in the applet scope for the page in the URL. It should only contain lowercase letters, numbers, and hyphens. Spaces and special characters are not allowed.")}</p>


                        <div className='mt-4 flexc'>
                            <input ref={(el) => this.slugInput = el} pattern='^[a-z0-9]+(?:-[a-z0-9]+)*$' className='modern-input3 mrd-3 w-100 text-semibold px-3' style={{ borderRadius: '30px' }} value={this.state.slug} onChange={(e) => this.setState({ slug: e.target.value })} placeholder={translate("Page slug ...")} />

                            <ButtonAnimated
                                iconwidth='24px'
                                onClick={this.submitSlug}
                                title={translate("Submit")}
                                icon='/assets/icons/plus-white.svg'
                                textColor={colors?.textColor ?? '#fff'}
                                invert={colors?.iconInvert}
                                bg={colors?.background ?? '#007aff'}
                                isLoading={this.state.isLoadingSlug}
                            />

                        </div>
                    </div>
                </Modal>





                <Modal ref={el => this.paramsModal = el} maxWidth={400}>
                    <div className="d-flex flex-column px-3 pt-4 pb-5 br-15 bg-white">

                        <div className='flexcb w-100 px-1'>
                            <p className='text-semibig text-bold'>{translate(`Edit page params`)}</p>

                            <ButtonAnimated
                                iconwidth='24px'
                                onClick={this.submitParamsValue}
                                title={translate("Submit")}
                                icon='/assets/icons/plus-white.svg'
                                textColor={colors?.textColor ?? '#fff'}
                                invert={colors?.iconInvert}
                                bg={colors?.background ?? '#007aff'}
                            />
                        </div>

                        <div className='px-1'>
                            <p className='text-smaller mt-2 color-gray-2'>{translate("The slug is the unique identifier in the applet scope for the page in the URL. It should only contain lowercase letters, numbers, and hyphens. Spaces and special characters are not allowed.")}</p>
                        </div>

                        <div className='mt-4 pb-3' style={{ borderBottom: '1px solid #eee' }}>

                            <div className='flexcb mb-1 px-1'>
                                <p className='text-semibold font-size-15'>{translate('Path params')}</p>
                                <button className='text-link flexcc' onClick={() => this.addParam('path')} >
                                    <p className='text-smaller' >{translate("Add Path Param")}</p>
                                </button>
                            </div>

                            <div className='w-100'>

                                <div style={{ position: "fixed", top: "0", left: "0" }} ref={(el) => (this.setPositionDiv = el)}></div>

                                <DragDropContext onDragEnd={(result) => this.onDragEnd(result, 'path')}>
                                    <Droppable droppableId="droppable-1" >
                                        {(provided) => (
                                            <div className="py-2" {...provided.droppableProps} ref={provided.innerRef}>

                                                {pathParams && pathParams.map((param, index) => {
                                                    return (
                                                        // <div key={param.id}>

                                                        <Draggable key={param.id} draggableId={param.id} index={index}>
                                                            {(provided, snapshot) => {

                                                                if (snapshot.isDragging) {
                                                                    if (!provided.draggableProps) {
                                                                        provided.draggableProps = { style: { zIndex: "999" } };
                                                                    }
                                                                    let bound = getBoundingClientRect(this.setPositionDiv.current);
                                                                    const offset = { x: bound.left, y: bound.top };
                                                                    const x = (provided.draggableProps?.style?.left ?? 0) - offset.x;
                                                                    const y = (provided.draggableProps?.style?.top ?? 0) - offset.y;
                                                                    provided.draggableProps.style.left = x;
                                                                    provided.draggableProps.style.top = y;
                                                                    // provided.draggableProps.style.position = 'absolute';
                                                                    provided.draggableProps.style.boxShadow = "0px 0px 10px #10101020";
                                                                    provided.draggableProps.style.zIndex = "1";
                                                                    provided.draggableProps.style.borderRadius = "4px"
                                                                    provided.draggableProps.style.background = "#ffffffcc"

                                                                }
                                                                return (
                                                                    <>
                                                                        <div className='flexcb  py-2 px-1' style={{ background: '#fff' }} key={param.id} ref={provided.innerRef} {...provided.draggableProps}>
                                                                            <div className='flexc'>
                                                                                {/* <div className='flexcc pt-1'>
                                                                        <img className='mrd-2' src='/assets/icons/useful/link.svg' alt='' height={14} />
                                                                    </div> */}
                                                                                <div className='mrd-2' {...provided.dragHandleProps}>
                                                                                    <img className='flexcc' src='/assets/icons/useful/drag-1.png' height={14} alt='' />
                                                                                </div>
                                                                                <p className={'font-size-14 '+ (param.required ? 'required' : '')}>{param.name}</p>

                                                                                <div className='flexc mld-3'>
                                                                                    {/* <p className=' font-size-12 mld-3 color-gray-2'>{"{{URL}}"}</p> */}
                                                                                    {pathParams.map((param, dindex) => {
                                                                                        if (dindex <= index) {
                                                                                            return (
                                                                                                <p className=' font-size-12 mld-1 color-gray-2'> <span className=''>/</span><span className={'mx-1 ' + (index == dindex ? 'px-1 py-1 br-4 ' : '')} style={{ background: index == dindex ? '#f0f0f0' : '' }}>{param.name}</span></p>

                                                                                            )
                                                                                        }
                                                                                    })}
                                                                                </div>
                                                                            </div>
                                                                            <div ref={el => this[`actions-${param.id}`] = el} className={'flexcc stage-action-button cursor-pointer '} onClick={(e) => { this[`fixedView-${param.id}`].showView() }}  >
                                                                                <img className='stage-action-button-img' src={'/assets/icons/useful/action.png'} height={10} width={10} style={{ height: '10px', width: '10px' }} alt='' />
                                                                            </div>
                                                                        </div>

                                                                        {this.state.showFixedViews && (
                                                                            <FixedView ref={el => this[`fixedView-${param.id}`] = el} nodeRef={this[`actions-${param.id}`]} topOffset={-10} xOffset={-32} zIndex={15} width={150} >
                                                                                <div className='bg-white br-10 p-2 shadow-3 sc-gray2 ' style={{ maxHeight: '350px', overflowY: 'scroll' }}>

                                                                                    {Array.isArray(this.state.paramsActions) && this.state.paramsActions.map((item, index) => {

                                                                                        return (

                                                                                            <div className='w-100 br-4' key={item.id} >

                                                                                                <button className="flexcb w-100 hover-gray-no-filter p-2 br-5" onClick={() => this.actionClicked(item, param)}>
                                                                                                    <div className='d-flex'>
                                                                                                        <div className='flexcc'>
                                                                                                            <img className='toolbar-icon flexcc' width={16} height={16} style={{ objectFit: 'contain' }} src={item.icon} alt='' />
                                                                                                        </div>
                                                                                                        <div>
                                                                                                            <div>
                                                                                                                <p className="font-size-12 mld-3 main-c3 text-start text-semibold" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{checkTranslation(item.label)}</p>

                                                                                                            </div>

                                                                                                        </div>

                                                                                                    </div>

                                                                                                </button>

                                                                                            </div>


                                                                                        )

                                                                                    })}
                                                                                </div>
                                                                            </FixedView>
                                                                        )}

                                                                    </>
                                                                )
                                                            }}
                                                        </Draggable>
                                                        // </div>
                                                    )
                                                })}

                                                {provided.placeholder}

                                            </div>
                                        )}

                                    </Droppable>
                                </DragDropContext>

                            </div>


                            {pathParams.length == 0 && (
                                <p className='text-center font-size-13 color-gray-2 mt-1'>{translate('No URL params')}</p>
                            )}

                        </div>


                        <div className='mt-4 '>

                            <div className='flexcb'>
                                <p className='text-semibold font-size-15'>{translate('Query params')}</p>
                                <button className='text-link flexcc' onClick={() => this.addParam('query')} >
                                    <p className='text-smaller' >{translate("Add Query Param")}</p>
                                </button>
                            </div>



                            <div className='w-100'>

                                <div style={{ position: "fixed", top: "0", left: "0" }} ref={(el) => (this.setPositionDiv = el)}></div>

                                <DragDropContext onDragEnd={(result) => this.onDragEnd(result, 'query')}>
                                    <Droppable droppableId="droppable" >
                                        {(provided) => (
                                            <div className="py-2" {...provided.droppableProps} ref={provided.innerRef}>

                                                {queryParams && queryParams.map((param, index) => {
                                                    return (
                                                        // <div key={param.id}>

                                                        <Draggable key={param.id} draggableId={param.id} index={index}>
                                                            {(provided, snapshot) => {

                                                                if (snapshot.isDragging) {
                                                                    if (!provided.draggableProps) {
                                                                        provided.draggableProps = { style: { zIndex: "999" } };
                                                                    }
                                                                    let bound = getBoundingClientRect(this.setPositionDiv.current);
                                                                    const offset = { x: bound.left, y: bound.top };
                                                                    const x = (provided.draggableProps?.style?.left ?? 0) - offset.x;
                                                                    const y = (provided.draggableProps?.style?.top ?? 0) - offset.y;
                                                                    provided.draggableProps.style.left = x;
                                                                    provided.draggableProps.style.top = y;
                                                                    // provided.draggableProps.style.position = 'absolute';
                                                                    provided.draggableProps.style.boxShadow = "0px 0px 10px #10101020";
                                                                    provided.draggableProps.style.zIndex = "1";
                                                                    provided.draggableProps.style.borderRadius = "4px"
                                                                    provided.draggableProps.style.background = "#ffffffcc"

                                                                }
                                                                return (
                                                                    <>
                                                                        <div className='flexcb  py-2 px-1' style={{ background: '#fff' }} key={param.id} ref={provided.innerRef} {...provided.draggableProps}>
                                                                            <div className='flexc'>
                                                                                {/* <div className='flexcc pt-1'>
                                                                        <img className='mrd-2' src='/assets/icons/useful/link.svg' alt='' height={14} />
                                                                    </div> */}
                                                                                <div className='mrd-2' {...provided.dragHandleProps}>
                                                                                    <img className='flexcc' src='/assets/icons/useful/drag-1.png' height={14} alt='' />
                                                                                </div>
                                                                                <p className={'font-size-14 ' + (param.required ? 'required' : '')}>{param.name}</p>


                                                                                <p className=' font-size-12 mld-3 color-gray-2'><span className={'mrd-2 px-1 py-1 br-4'} style={{ background: '#f0f0f0' }}>{param.name}</span>= {"< " + param.name + " >"}</p>


                                                                            </div>

                                                                            <div ref={el => this[`actions-${param.id}`] = el} className={'flexcc stage-action-button cursor-pointer '} onClick={(e) => { this[`fixedView-${param.id}`].showView() }}  >
                                                                                <img className='stage-action-button-img' src={'/assets/icons/useful/action.png'} height={10} width={10} style={{ height: '10px', width: '10px' }} alt='' />
                                                                            </div>



                                                                            {/* <button className='text-link flexcc' style={{ color: '#ee5050' }} onClick={() => this.removeHandler(index)} >
                                                                            <p className='text-smaller'  >{translate("Remove")}</p>
                                                                        </button> */}

                                                                        </div>
                                                                        {this.state.showFixedViews && (
                                                                            <FixedView ref={el => this[`fixedView-${param.id}`] = el} nodeRef={this[`actions-${param.id}`]} topOffset={-10} xOffset={-32} zIndex={15} width={150} >
                                                                                <div className='bg-white br-10 p-2 shadow-3 sc-gray2 ' style={{ maxHeight: '350px', overflowY: 'scroll' }}>

                                                                                    {Array.isArray(this.state.paramsActions) && this.state.paramsActions.map((item, index) => {

                                                                                        return (

                                                                                            <div className='w-100 br-4' key={item.id} >

                                                                                                <button className="flexcb w-100 hover-gray-no-filter p-2 br-5" onClick={() => this.actionClicked(item, param)}>
                                                                                                    <div className='d-flex'>
                                                                                                        <div className='flexcc'>
                                                                                                            <img className='toolbar-icon flexcc' width={16} height={16} style={{ objectFit: 'contain' }} src={item.icon} alt='' />
                                                                                                        </div>
                                                                                                        <div>
                                                                                                            <div>
                                                                                                                <p className="font-size-12 mld-3 main-c3 text-start text-semibold" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{checkTranslation(item.label)}</p>

                                                                                                            </div>

                                                                                                        </div>

                                                                                                    </div>

                                                                                                </button>

                                                                                            </div>


                                                                                        )

                                                                                    })}
                                                                                </div>
                                                                            </FixedView>
                                                                        )}
                                                                    </>
                                                                )
                                                            }}
                                                        </Draggable>
                                                        // </div>
                                                    )
                                                })}

                                                {provided.placeholder}

                                            </div>
                                        )}

                                    </Droppable>
                                </DragDropContext>

                            </div>


                            {queryParams.length == 0 && (
                                <p className='text-center font-size-13 color-gray-2 mt-1'>{translate('No query params')}</p>
                            )}





                        </div>
                    </div>
                </Modal>





                <Modal ref={el => this.editParamModal = el} maxWidth={400}>
                    <div className="d-flex flex-column p-4 pb-5 br-15 bg-white">
                        <p className='text-semibig text-bold'>{translate(`${!this.state.currentParam?.id ? "Add" : 'Edit'} ${this.state.currentParam?.type} param`)}</p>

                        {/* <p className='text-smaller mt-2 color-gray-2'>{translate("The slug is the unique identifier in the applet scope for the page in the URL.")}</p> */}


                        <div className='mt-4  w-100'>

                            <div className='mb-4 w-100'>
                                <p className='font-size-14 mb-2 required'>{translate("Name")}</p>
                                <input ref={(el) => this.slugInput = el} pattern='^[a-z0-9]+(?:-[a-z0-9]+)*$' className='modern-input3 mrd-3 w-100 text-semibold px-3 mb-2 br-8' value={this.state.currentParam?.name} onChange={(e) => this.changeCurrentParamValue('name', e.target.value)} placeholder={translate("Name ...")} />
                                <p className='font-size-12 color-gray-2 mb-3 px-1'>{translate("Name should only contain lowercase letters, numbers, and hyphens. Spaces and special characters are not allowed.")}</p>

                                <div className='flexc mb-2'>
                                    <SwitchInput data={this.state.currentParam?.required} header={{ key: 'required', information: {} }} changeValue={this.changeCurrentParamValue} />
                                    <p className='font-size-14 mx-2'>{translate("Required")}</p>

                                </div>
                            </div>

                            <ButtonAnimated
                                iconwidth='24px'
                                onClick={this.submitParam}
                                title={translate("Submit")}
                                icon='/assets/icons/plus-white.svg'
                                textColor={colors?.textColor ?? '#fff'}
                                invert={colors?.iconInvert}
                                bg={colors?.background ?? '#007aff'}
                            />

                        </div>
                    </div>
                </Modal>



            </div>
        );
    }
}

// export default ApisInput;

const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(ApisInput);
